import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import Formations from "../components/Formations"
import formations from "../services/formations.json"
import { constructParams } from "../services/functions"
import { AcademicLevel, Adresse, Campus, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { adresse, consent, consentement, defaultValues, getCampus, specialities } from "services"
import MentionsLegales from "components/MentionsLegales"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('EPITA-DOC')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      ...specialities,
      formations: [],
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        ...adresse,
        Apprentissage__c: false,
        Bachelor__c: false,
        CycleInge__c: false,
        IA_Institut__c: false,
        Master__c: false,
        Section__c: '',
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campus = lead.Campus__c
    const defaultDataLead = {
      Division__c: 'EPITA',
      IONISSchool__c: 'EPITA',
      LastForm__c: 'Documentation PDF',
      LeadSource: 'Internet: Demande de doc',
      PDFdownloaded__c: true,
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      // await salesforce.createLead(finalLead)
      await submission({
        formId: 'DOC',
        lead: finalLead,
        utmCookieName: '_ionis_user_data' // optionnel
      })
      const params = constructParams(data.formations, formations)
      document.location.href = `${url}?ville=${campus}${params}&niveau=${encodeURIComponent(lead.AcademicLevel__c)}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const choix = watch('choix')
  // useEffect
  useSalesforce('EngineeringSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" />
        </Grid>
        {choix !== 'recevoir' && (
          <>
            <Grid item sm={6} xs={12}>
              <InputText control={control} label="Code postal" name="lead.PostalCode" required />
            </Grid>
            <Grid item sm={6} xs={12}>
            </Grid>
          </>
        )}
        <AcademicLevel school="EPITA" />
        <Campus label="Campus d'intérêt" options={getCampus('EPITA')} />
        <Formations />
        {choix === 'recevoir' && (
          <Adresse />
        )}
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Documentation" school="EPITA" />
      </Grid>
    </FormProvider>
  )
}

export default Form
